import { render, staticRenderFns } from "./MenuLateralDireito.vue?vue&type=template&id=0a8fdbac&scoped=true"
import script from "./MenuLateralDireito.vue?vue&type=script&lang=js"
export * from "./MenuLateralDireito.vue?vue&type=script&lang=js"
import style0 from "./MenuLateralDireito.vue?vue&type=style&index=0&id=0a8fdbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8fdbac",
  null
  
)

export default component.exports